import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import { Badge } from '../atoms';
import {
  Bottom as BottomDetail,
  Info as InfoDetail,
} from '../public/PublicReportCard/PublicReportCard.styles';

export const ReportImage = styled.img`
  height: 70px;
`;

export const SubmissionType = styled.span`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  font-weight: 600;
  font-size: 14px;
  margin: 0;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 100%;
  padding-left: 10px;
  flex-grow: 2;
`;

export const Row = styled(Column)`
  flex-direction: row;
`;

export const ReportDetail = styled.span`
  color: grey;
`;

export const Bottom = styled(BottomDetail)`
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const Info = styled(InfoDetail)`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  font-size: 12px;
  box-shadow: none;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    flex-direction: column;
    padding-top: 5px;
    box-shadow: 0px 0px 11px -1px rgba(150, 150, 150, 0.3);
  }
`;

export const Link = styled(RouterLink)`
  text-decoration: none;
`;

export const StyledBadge = styled(Badge)`
  align-self: center;
  margin-bottom: 12px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;
